import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';

import { GET_ADMIN_CONSENT_URL } from '../../../users/queries.ts';

const useAdminConsentLink = (isPersonalMailbox: boolean, isEnabled = true) => {
    const [getAdminConsentUrl] = useMutation(GET_ADMIN_CONSENT_URL);
    const [link, setLink] = useState('');

    useEffect(() => {
        if (!isEnabled || link) return;
        getAdminConsentUrl({ variables: { isPersonalMailbox } })
            .then(({ data }) => {
                if (data?.getAdminConsentUrl?.adminConsentUrl) setLink(data.getAdminConsentUrl.adminConsentUrl);
            })
            .catch((error) =>
                console.error(`Failed to fetch ${isPersonalMailbox ? 'personal' : 'shared'} admin consent URL:`, error)
            );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEnabled]);

    return link;
};

export default useAdminConsentLink;
